/**
 * Public variant names for `app-button`. Maps to `.ct-btn-*` in
 * `packages/scss-assets/src/lib/_buttons.scss` via {@link BUTTON_VARIANT_CSS_SUFFIX}.
 */
export type ButtonVariant =
  | 'primary'
  | 'white-red'
  | 'white-green'
  | 'white-grey'
  | 'ai'
  | 'link'
  | 'ghost';

/** Maps each public variant to the SCSS class suffix (after `ct-btn-`). */
export const BUTTON_VARIANT_CSS_SUFFIX: Record<ButtonVariant, string> = {
  primary: 'primary',
  'white-red': 'white-red',
  'white-green': 'white-green',
  'white-grey': 'white-grey',
  ai: 'kira',
  link: 'link',
  ghost: 'ghost',
};

export type ButtonHtmlType = 'button' | 'submit' | 'reset';
